export const PLAYER_EVENTS = {
  FAIL: 'fail',
  PLAY: 'play',
  DEBUG: 'debug',
};

export const PUBLISHER_EVENTS = {
  STREAMING: 'streaming',
};

export const PUBLISHER_STATUSES = {
  INITIALIZING: 'initializing',
  STREAMING: 'streaming',
  STOPPED: 'stopped',
};

export const MEDIA_ELEMENT_EVENTS = {
  MEDIA_ELEMENT_PLAY: 'play',
  MEDIA_ELEMENT_PAUSE: 'pause',
  MEDIA_ELEMENT_PROGRESS: 'progress',
  MEDIA_ELEMENT_EMPTIED: 'emptied',
  MEDIA_ELEMENT_SUSPEND: 'suspend',
  MEDIA_ELEMENT_STALLED: 'stalled',
  MEDIA_ELEMENT_WAITING: 'waiting',
  MEDIA_ELEMENT_RATECHANGE: 'ratechange',
  MEDIA_ELEMENT_PLAYING: 'playing',
};
